import styled, { css } from "styled-components"
import { Link } from "react-scroll"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"

export const MapImage = styled.div`
  grid-column: 1 / -1;
  justify-self: center;
  width: 100vw;
  margin: 0 -20px;

  @media (min-width: ${Breakpoints.md}) {
    margin: 0 -40px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    max-width: 1440px;
    max-height: 512px;
    overflow: hidden;
    & > * {
      max-height: 512px;
    }
  }
`

export const Title = styled.h2`
  ${mobileTextStyles.MobileHeadingTwoSemiBold}
  margin-top: 64px;
  color: var(--slate);
  grid-column: 3 / -3;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoBold}
    grid-column: 4 / -4;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoBold}
  }
`

export const BodyText = styled.p`
  ${mobileTextStyles.MobileBodyRegular}
  font-size: 16px;
  color: var(--body-text-grey);
  text-align: center;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletBodyRegular}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
  }
`

export const DownloadIcon = styled.img`
  margin-right: 16px;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: -1 / 1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: -2 / 2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 4 / -4;
  }
`

export const DownloadLinkContainer = styled.div`
  align-self: center;
  justify-self: center;
  max-width: 320px;
`

export const ContactUsLinkContainer = styled.div`
  align-self: center;
  justify-self: center;
  max-width: 272px;
  width: 100%;
  margin-bottom: 64px;

  @media (min-width: ${Breakpoints.lg}) {
    max-width: 176px;
    margin-bottom: 80px;
  }
`

export const downloadLinkCss = css`
  margin-top: 32px;
  line-height: 14px;

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
  }
`
export const ContactLink = styled(Link)`
  ${desktopTextStyles.LinkText}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  flex-grow: 1;
  color: var(--burnt-orange);
  background-color: var(--white);
  margin-top: 16px;
  border: 1px solid var(--burnt-orange);
  line-height: 14px;
  cursor: pointer;
`
